export default "__VITE_ASSET__CqZUtUq___"